function Projects() {
    return (
        <section>
            <h2>Projetos</h2>

            <div className="card-grid">

                <a className="card" style={{ textDecoration: 'none' }} href="https://github.com/Luanz1nn/Calculadora" target="_blank" rel="noopener noreferrer">
                    <h3>Calculadora</h3>
                    <p>Projeto de uma calculadora desenvolvida em React.</p>
                </a>

                <a className="card" style={{ textDecoration: 'none' }} href="https://github.com/Luanz1nn/Pokedex" target="_blank" rel="noopener noreferrer">
                    <h3>Pokedex</h3>
                    <p>Um catálogo de pokémons desenvolvido em React.</p>
                </a>

                <a className="card" style={{ textDecoration: 'none' }} href="https://github.com/Luanz1nn/Portfolio-Lz1" target="_blank" rel="noopener noreferrer">
                    <h3>Portfólio React</h3>
                    <p>Website pessoal desenvolvido em React com design moderno.</p>
                </a>

                <a className="card" style={{ textDecoration: 'none' }} href="https://github.com/Luanz1nn/Catalogo-de-Plantas" target="_blank" rel="noopener noreferrer">
                    <h3>Nativas PE</h3>
                    <p>Um Web catálogo de plantas nativas de Pernambuco.</p>
                </a>

                <a className="card" style={{ textDecoration: 'none' }} href="https://github.com/Luanz1nn/Luan-Player-Music" target="_blank" rel="noopener noreferrer">
                    <h3>Luan Music</h3>
                    <p>Projeto de um player de música desenvolvido em React.</p>
                </a>

                <a className="card" style={{ textDecoration: 'none' }} href="https://github.com/Luanz1nn/Stopwatch" target="_blank" rel="noopener noreferrer">
                    <h3>Stopwatch</h3>
                    <p>Projeto de um cronômetro desenvolvido em Javascript, html e css.</p>
                </a>


            </div>

        </section>
    )
}

export default Projects
